"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFunction = exports.isString = exports.isEqual = void 0;
var isFunction = function (obj) {
    return typeof obj === "function";
};
exports.isFunction = isFunction;
var isString = function (obj) {
    return typeof obj === "string";
};
exports.isString = isString;
var _isEqualObject = function (obj, obj2) {
    if (!obj) {
        obj = {};
    }
    if (!obj2) {
        obj2 = {};
    }
    var objKeys = Object.keys(obj);
    var obj2Keys = Object.keys(obj2);
    if (objKeys.length !== obj2Keys.length) {
        return false;
    }
    var index;
    var key;
    for (index = 0; index < objKeys.length; index++) {
        key = objKeys[index];
        // eslint-disable-next-line
        if (!isEqual(obj[key], obj2[key])) {
            return false;
        }
    }
    return true;
};
var _isEqualArray = function (obj, obj2) {
    if (obj.length !== obj2.length) {
        return false;
    }
    var index;
    for (index = 0; index < obj.length; index++) {
        // eslint-disable-next-line
        if (!isEqual(obj[index], obj2[index])) {
            return false;
        }
    }
    return true;
};
var _isEqualPrimative = function (obj, obj2) {
    return obj === obj2;
};
var isEqual = function (obj, obj2) {
    if (typeof obj !== typeof obj2) {
        return false;
    }
    if (Array.isArray(obj)) {
        return _isEqualArray(obj, obj2);
    }
    else if (typeof obj === "object") {
        return _isEqualObject(obj, obj2);
    }
    else {
        return _isEqualPrimative(obj, obj2);
    }
};
exports.isEqual = isEqual;
//# sourceMappingURL=truthy.js.map